import { Router } from '@angular/router';
import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { Account } from './../models/account';
import { Auth } from './../Auth';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AutenticationEventType } from '../autentication.event.type';
import { TweenMax, Quint, Power2, Sine } from 'gsap';
import { AutenticationService } from '../autentication.service';
import { EventTypes } from '../../shared/EventTypes';
import { User } from '../models/user';
import { AuthMessage } from '../models/auth-message';
import { AppConfig } from '../../AppConfig';
import * as moment from 'moment';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { ThemeService } from '../../shared/theme-service/theme.service';
import { OAuthTokenService } from '../o-auth-token.service';

@Component({
	selector: 'app-user-and-pass',
	templateUrl: './user-and-pass.component.html',
	styleUrls: ['./user-and-pass.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class UserAndPassComponent implements OnInit {

	accounts: Array<Account>;
	formLogin: FormGroup;
	cpf: string;
	canSend = false;
	passwordError = false;
	passwordBlocked:boolean = false;
	attemptsLeft = Auth.attemptsCount;
	sending = false;
	hasCookie = false;
	active = false;
	scrollHeight = 180;
	open = false;
	accountsList: Array<Account> = [];
	showAccountsList = false;
	filteredAccountList: Account[];
	findedAccount: Account[];
	selectedAccount: any;
	user: User;
	cookieAccounts: Array<Account> = [];
	passToSend = '';
	disabled = false;

	constructor(
		private router: Router,
		private authService: AutenticationService,
		private formBuilder: FormBuilder,
		private themeService: ThemeService,
		private oAuthToken: OAuthTokenService,
  	) {
		this.formLogin = formBuilder.group({
			'cpf': [null, Validators.required],
			'pass': ['', Validators.required]
		});
	}

	ngOnInit() {
		AppEventDispatcher.listen( AutenticationEventType.LOGIN.USER_AND_PASS, (data) => {
			this.active = true;
			this.show(data);
		});

		if (JSON.parse(Cookie.get('OmniAccountsList'))) {

			this.cookieAccounts = JSON.parse(Cookie.get('OmniAccountsList'));
			this.user = this.cookieAccounts['0'].user;
			this.hasCookie = true;
			this.accountsList = this.cookieAccounts.filter(this.accountsFilter, this.user.accountNumber);

			this.formLogin.controls.cpf.setValue(this.user.cpf);

			if (this.accountsList.length > 0) {
				this.showAccountsList = true;
			}
		}

	}

	verifyPassword(password) {

		if ( password.length === 6 ) {
			this.canSend = true;
		} else {
			this.canSend = false;
		}

	}

	checkAccessPix() {
		this.authService.getPixAccessAvailable().subscribe(data => {
			if (data.Sucesso) {
				const user: User = Auth.getInstance().getUser();
				user.accessPix = data.Retorno;
				Auth.getInstance().setUser(user);
				AppEventDispatcher.dispatch(EventTypes.MENU.CHANGE, { show: true });
			}
		});
	}

	send() {

		if ( !this.sending && this.formLogin.valid && this.canSend ) {
			this.disabled = true;
			this.formLogin.disable();
			this.passwordError = false;
			this.sending = true;

			this.authService.loadAccounts(this.formLogin.value.cpf, this.passToSend).subscribe( (data: any) => {
				this.oAuthToken.auth(this.formLogin.value.cpf, this.passToSend).subscribe(({ refresh_token }) => {
					sessionStorage.setItem('_OmniBearerRefreshV2', refresh_token);
					this.sending = false;
					this.formLogin.controls.pass.setValue('');
					this.disabled = false;
					this.checkAfterTerms();
				})
			}, error => {

				this.sending = false;
				this.canSend = true;
				this.formLogin.enable();
				this.passwordError = true;
				this.disabled = false;
				if (error.error.Mensagem.includes('bloqueada')) {
					this.passwordBlocked = true;
					this.canSend = false;
					error.error.Mensagem += ' Entre em contato com a Central de Relacionamento para fazer o desbloqueio.';
				}

				this.attemptsLeft = error.error.TentativasRestantes;

				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });

				// TODO: FAZER VALIDAÇÃO DE ACORDO COM O SERVIÇO
				// if (error.error.Tipo === 'bloqueio' || this.attemptsLeft < 1) {
				// 	Auth.getInstance().blockLogin(moment(error.error.ExpiracaoBloqueio).utc(true));
				// 	this.hide(true);
				// 	AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.PASS_MONITOR_BLOCKED, {delay: .2});
				// } else if (error.error.TentativasRestantes < 2) {
				// 	this.hide(true);
				// 	AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.PASS_MONITOR, {delay: .2});
				// } else {
				// 	AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				// }
			});

		}

	}

	checkAfterTerms() {

		if (Auth.getInstance().getAccountsList().length > 1 && !this.hasCookie) {
			this.hide(false);
			AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.ACCOUNTS_LIST, {delay: .2});
		} else if (Auth.getInstance().getAccountsList().length > 0 && !this.hasCookie) {

			this.sending = true;
			// Configura a única conta e usuário que existe e efetua o login
			const user: User = Auth.getInstance().getAccountsList()[0].user;

			Auth.getInstance().setUser(user);

			this.authService.setAccount().subscribe( account => {
				this.checkAccessPix();
				this.sending = false;

				if (!Auth.hasSecurityQuestions) {
					this.hide(false);
					AppEventDispatcher.dispatch(AutenticationEventType.SECURITY_CHECK_REGISTRATION.INIT, { show: true });
				} else {
					this.router.navigate(['']);
				}

			}, error => {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			});
		} else {
			this.sending = true;
			// Verifica se foi feita a seleção de outra conta, se não efetua o login com a primeira conta da lista
			if (this.user !== undefined) {
				const user: User = this.user;

				Auth.getInstance().setUser(user);
			} else {
				const user: User = Auth.getInstance().getAccountsList()[0].user;

				Auth.getInstance().setUser(user);
			}

			this.authService.setAccount().subscribe( account => {
				this.checkAccessPix();
				this.sending = false;
				if (!Auth.hasSecurityQuestions) {
					this.hide(false);
					AppEventDispatcher.dispatch(AutenticationEventType.SECURITY_CHECK_REGISTRATION.INIT, { show: true });
				} else {
					this.router.navigate(['']);
				}
			}, error => {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			});
		}
	}

	useAnotherUser() {
		Cookie.delete('OmniAccountsList');
		this.hide(false, true);
		this.accountsList = [];
		AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.MY_CPF, {delay: .4, direction: 'LEFT_TO_RIGHT'});
	}

	show(data) {

		this.passwordBlocked = false;

		if (Auth.cpf !== '') {
			this.formLogin.controls.cpf.setValue(Auth.cpf);
		}

		const interval = setInterval(() => {

			if ($('[data-component="user-and-pass"]').length > 0) {

				clearInterval(interval);

				if (data.direction === 'LEFT_TO_RIGHT') {
					TweenMax.set('[data-component="user-and-pass"]', {left: '-150%'});
				}
				TweenMax.to('[data-component="login"]', .8, { height: 600, ease: Sine.easeOut});
				TweenMax.to('[data-component="user-and-pass"]', .8, {delay: data.delay, left: '50%', ease: Quint.easeOut});
			}

		}, 10);

	}

	hide(active, toRigh = false) {

		this.hasCookie = false;

		if (toRigh) {
			TweenMax.to('[data-component="user-and-pass"]', 1.2, {left: '150%', ease: Quint.easeOut});
		} else {
			TweenMax.to('[data-component="user-and-pass"]', 1.6, {left: '-100%', ease: Quint.easeOut});
		}

		TweenMax.delayedCall(.6, () => {
			this.hasCookie = false;
			this.active = active;
			this.canSend = false;
		});
	}

	openMenuProfile(open) {
		this.open = open;

		if (this.open) {
			this.open = false;
		} else {
			this.open = true;
		}

		this.toggle();
	}

	toggle() {
		const contentProfile = this.scrollHeight;
		let listProfile = 0;

		if ($(document).width() < 992) {
			listProfile = $('[data-component="main-menu"] [data-component="profile"] .profile-list').outerHeight() + 1;
		} else {
			listProfile = $('[data-component="header"] [data-component="profile"] .profile-list').outerHeight() + 1;
		}

		if (this.open) {
			if (contentProfile > listProfile) {
				TweenMax.to('[data-component="profile"] .profile-dropdown', .7, {
					height: listProfile,
					ease: Power2.easeOut
				});

				this.arrowUp();

			} else {
				TweenMax.to('[data-component="profile"] .profile-dropdown', .7, {
					height: contentProfile,
					ease: Power2.easeOut
				});

				this.arrowUp();

			}
		} else {
			TweenMax.to('[data-component="profile"] .profile-dropdown', .5, {
				height: 0,
				ease: Power2.easeOut
			});

			TweenMax.to('[data-component="profile"] .material-icons.arrow', .5, {
				rotation: 0
			});
		}
	}

	arrowUp() {
		TweenMax.to('[data-component="profile"] .material-icons.arrow', .5, {
			rotation: 180
		});
	}

	selectAccount(account) {
		this.selectedAccount = account;
		this.findedAccount = this.cookieAccounts.filter(this.accountCompare, this.selectedAccount);

		this.filteredAccountList = this.cookieAccounts.filter(this.accountsFilter, this.selectedAccount);

		this.user = this.findedAccount[0].user;

		this.formLogin.controls.cpf.setValue(this.findedAccount[0].user.cpf);

		this.accountsList = this.filteredAccountList;

		this.openMenuProfile(true);
	}


	accountsFilter(item, index, array) {
		return (item.user.accountNumber !== this);
	}

	accountCompare(item, index, array) {
		return (item.user.accountNumber === this);
	}

	forgot() {

		if (!this.sending) {

			Auth.definePassword = false;

			const message = new AuthMessage();
			message.buttonTitle = 'Continuar';
			message.delay = .2;
			message.eventToDispatch = AutenticationEventType.LOGIN.SECURITY_CHECK;
			message.eventData = { show: true };
			message.hasButton = true;
			message.title = 'Olá, vamos redefinir sua senha?';
			message.text = 'Vamos te ajudar a redefini-la, é fácil e rápido. Vamos lá?';
			message.withPreload = true;

			this.hide(false);
			TweenMax.delayedCall(.2, () => {
				TweenMax.to('[data-component="login"]', .8, { width: '100%', ease: Sine.easeOut});
				TweenMax.to('[data-component="login"] .logo', .8, { scale: .85, top: 25, ease: Sine.easeOut});

				AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.AUTH_MESSAGE, message);
			});

		}

	}

	keyDownHandler(event: Event) {
		event.preventDefault();
	}

	onCorrect() {
		this.passToSend = '';
		this.formLogin.controls.pass.setValue('');
		this.passwordError = false;
	}

	setInputValueFromKeyPad(val) {

		if (this.formLogin.controls.pass.value.length < 6) {
			this.passToSend += val[0].toString() + val[1].toString();
			this.formLogin.controls.pass.setValue(this.formLogin.controls.pass.value.toString() + val[0].toString());
		}

		this.formLogin.controls.pass.updateValueAndValidity();

		this.verifyPassword(this.formLogin.controls.pass.value);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/user-and-pass/user-and-pass.component.ts